import { Component, Input, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { AoiService } from '../../../services/aoi.service';
import { GeocodeService, IGeocodeResult } from '../../../services/geocode.service';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-address',
    templateUrl: './address.component.html',
    styleUrls: ['../../sharedStyles/base.scss', './address.component.scss']
})
export class AddressComponent extends BaseComponent {
    @Input()
    debounceTime: number = 200;

    @Input()
    maxSuggestionNumber: number = 10;

    suggestions: IGeocodeResult[] = [];
    searchCriteria: any;

    queryField: FormControl = new FormControl();
    isActive: boolean;

    constructor(
        _vcr: ViewContainerRef,
        private readonly geocodeService: GeocodeService,
        private readonly aoiService: AoiService
    ) {
        super(_vcr, true);
    }

    @Input()
    public activate = () => {
        if (this.isActive) { return; }

        this.queryField.valueChanges.pipe(
            debounceTime(this.debounceTime),
            distinctUntilChanged(),
            switchMap(query => {
                if (!query || this.searchCriteria && query === this.searchCriteria.address) {
                    return;
                }

                this.searchCriteria = null;
                return this.geocodeService.suggest(query, this.maxSuggestionNumber);
            })
        ).subscribe(result => {
            if (result) {
                this.suggestions = result.suggestions;
            }
        });

        this.isActive = true;
    }

    @Input()
    public reset = () => {
        this.queryField.reset();
        this.searchCriteria = null;
        this.suggestions = [];
    }

    selectResult(suggestion) {
        this.searchCriteria = {
            type: 'address',
            address: suggestion.text,
            magicKey: suggestion.magicKey
        };
        this.queryField.setValue(suggestion.text);
    }

    @Input()
    public addResultToMap = async () => {
        if (this.searchCriteria) {
            this.aoiService.setSearchCriterias([this.searchCriteria]);
        }
        this.reset();
    }
}
